import React, { memo } from 'react';
import { useTradingSummaryState } from '~/modules/tradeSheet/tradingSummary/useTradingSummaryState';
import { tradeKeyValueBoxCss, tradeItemCss, tradeKeyCss, tradeValueCss, tradeLabelCss, } from '~/modules/tradeSheet/tradingSummary/tradingSummaryCss';
const PositionDuration = memo(function PositionDuration() {
    const { state } = useTradingSummaryState.useContainer();
    const { duration } = state;
    return (<>
      <p css={tradeLabelCss('#00aab6')}>持倉時間</p>
      <div css={tradeKeyValueBoxCss}>
        <div css={tradeItemCss}>
          <p css={tradeKeyCss}>平均交易持倉時間：</p>
          <p css={tradeValueCss}>{duration?.avgTime.toFixed(1)}天</p>
        </div>
        <div css={tradeItemCss}>
          <p css={tradeKeyCss}>平均獲利部位持倉時間：</p>
          <p css={tradeValueCss}>{duration?.winAvgTime.toFixed(1)}天</p>
        </div>
        <div css={tradeItemCss}>
          <p css={tradeKeyCss}>平均虧損部位持倉時間：</p>
          <p css={tradeValueCss}>{duration?.loseAvgTime.toFixed(1)}天</p>
        </div>
      </div>
    </>);
});
export default PositionDuration;
